export const siteHeadersIds = 'site-headers'
